module.exports = __webpack_public_path__ + "static/media/hiding_bros.5a9375b2.png";